export enum CalendarEventTypeId {
  assessmentSession,
  trainingProcess,
  scoringProcess,
  qualificationProcess,
}

export enum ProcedureTypeId {
  manual,
  automatic,
}

export enum ProcedureExecutionTypeId {
  beforeEventStartDate,
  beforeEventEndDate,
  atEventStartDate,
  atEventEndDate,
}

export enum MessageTypeId {
  one,
  push,
  email,
  sms,
}

export enum RecipientType {
  examiner,
  examiningTeamChairman,
  examTaskGroupCoordinator,
  domesticCoordinator,
  admin,
  okeAdmin,
  helpdesk,
}

export interface ProcedureAddressee {
  admin: boolean;
  helpdesk: boolean;
  okeAdmin: boolean;
  domesticCoordinator: boolean;
  examTaskGroupCoordinator: boolean;
  examiningTeamChairman: boolean;
  examiner: boolean;
}

export interface Message {
  title: string | null;
  content: string | null;
  messageTypeId: MessageTypeId | null;
}

export interface ProcedureDto {
  procedureId?: string;
  id?: string;
  name: string;
  plannedExecution?: string;
  procedureTypeId: ProcedureTypeId | null;
  procedureExecutionTypeId: ProcedureExecutionTypeId | null;
  procedureAddressee: ProcedureAddressee;
  message?: Message | null;
  messageTypeId?: MessageTypeId;
  plannedExecutionAdditionalHours: number | null;
  calendarEventTypeId?: CalendarEventTypeId;
  assessmentSessionId?: string;
  executed: boolean;
}

export interface Procedure {
  id: string;
  name: string;
  procedureStartTime: string;
  procedureTypeId: ProcedureTypeId;
  procedureRecipients: RecipientType[];
  messageTypeId: MessageTypeId;
  executed: boolean;
}

export interface ProceduresTableItem {
  [key: string]: string | number | boolean | JSX.Element;
  id: string;
  name: string;
  procedureStartTime: string;
  procedureTypeId: string;
  procedureRecipients: string;
  messageTypeId: string;
  procedureCompleted: 'TAK' | 'NIE';
  actions: JSX.Element;
}

export interface AssessmentSessionDateResponse {
  examTaskGroupNameAndSheetCode: string;
  assessmentSessionStart: string;
  assessmentSessionEnd: string;
  scoringStart: string;
  trainingStart: string | null;
  qualificationStart: string | null;
  assessmentSessionId: string;
  isDomesticCoordinator: boolean;
}

export interface AssessmentSessionDate {
  examTaskGroupNameAndSheetCode: string;
  assessmentSessionStart: Date;
  assessmentSessionEnd: Date;
  scoringStart: Date;
  trainingStart: Date | null;
  qualificationStart: Date | null;
  assementSessionId: string;
  isDomesticCoordinator: boolean;
}

export enum Month {
  Styczeń = 1,
  Luty,
  Marzec,
  Kwiecień,
  Maj,
  Czerwiec,
  Lipiec,
  Sierpień,
  Wrzesień,
  Październik,
  Listopad,
  Grudzień,
}
